<template>
    <client-page>
        <section class="section">
            <v-container>
                <!-- Mobile -->
                <v-img src="/images/sub/campaign/infant/mobile.jpg" class="infant-view infant-view--mobile">
                    <div class="infant-view__video">
                        <iframe v-bind="iframeProps" />
                    </div>

                    <template v-for="(btn, index) in buttonList">
                        <a :key="index" :href="buttonlink" target="_blank" class="infant-view__button" :class="`infant-view__button--${btn}`">{{ buttonText }}</a>
                    </template>
                </v-img>
                <!--// Mobile -->

                <!-- PC -->
                <v-img src="/images/sub/campaign/infant/image.jpg" class="infant-view infant-view--pc">
                    <div class="infant-view__video">
                        <iframe v-bind="iframeProps" />
                    </div>
                    <template v-for="(btn, index) in buttonList">
                        <a :key="index" :href="buttonlink" target="_blank" class="infant-view__button" :class="`infant-view__button--${btn}`">{{ buttonText }}</a>
                    </template>
                </v-img>
                <!--// PC -->
                <div class="mt-40 mt-lg-60">
                    <v-row justify="end" class="row--x-small">
                        <v-col cols="auto">
                            <!-- <v-btn @click="$router.go(-1)" outlined color="grey-9">목록보기</v-btn> -->
                            <v-btn to="/news/campaign" outlined color="grey-9">목록보기</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data: () => ({
        buttonList: ["top", "1", "2"],

        buttonlink: "https://secure.donus.org/withcan/pay/step1?_gl=1*180luv6*_ga*MTY5ODQ1OTg0Mi4xNzE3NDY4Mzcy*_ga_1KFQVNYJMP*MTczNjc1MjExNi4xMzAuMC4xNzM2NzUyMTE2LjYwLjAuMA",
        buttonText: "아이들 후원하기",

        iframeProps: {
            width: "100%",
            height: "100%",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
            referrerpolicy: "strict-origin-when-cross-origin",
            allowfullscreen: true,
            src: "https://www.youtube.com/embed/G0iuN10o3QE?si=Cnz_YbHkvPbuFFIK",
        },
    }),
};
</script>

<style lang="scss" scoped>
.infant-view {
    --image-width: 720;
    --image-height: 15474;
    position: relative;
    &--pc {
        display: none;
    }
    &__video,
    &__button {
        position: absolute;
        display: block;
    }
    &__video {
        --video-x: 30;
        --video-y: 1554;
        --video-width: 661;
        --video-height: 368;
        left: calc(var(--video-x) / var(--image-width) * 100%);
        top: calc(var(--video-y) / var(--image-height) * 100%);
        height: calc(var(--video-height) / var(--image-height) * 100%);
        width: calc(var(--video-width) / var(--image-width) * 100%);
        border-radius: 10px;
        overflow: hidden;
    }
    &__button {
        width: calc(var(--button-width) / var(--image-width) * 100%);
        height: calc(var(--button-height) / var(--image-height) * 100%);
        border-radius: 999px;
        text-align: center;
        font-size: 1rem;
        opacity: 0;
        &--1 {
            --button-width: 633;
            --button-height: 158;
            --button-1-x: 40;
            --button-1-y: 13834;
            left: calc(var(--button-1-x) / var(--image-width) * 100%);
            top: calc(var(--button-1-y) / var(--image-height) * 100%);
            border-radius: 0;
        }
        &--2 {
            --button-width: 320;
            --button-height: 96;
            --button-2-x: 200;
            --button-2-y: 15238;
            left: calc(var(--button-2-x) / var(--image-width) * 100%);
            top: calc(var(--button-2-y) / var(--image-height) * 100%);
        }
        &--top {
            --button-width: 440;
            --button-height: 96;
            --button-top-x: 140;
            --button-top-y: 1361;
            left: calc(var(--button-top-x) / var(--image-width) * 100%);
            top: calc(var(--button-top-y) / var(--image-height) * 100%);
        }
    }
}

@media (min-width: 723px) {
    .infant-view {
        --image-width: 1200;
        --image-height: 6659;
        &--mobile {
            display: none;
        }
        &--pc {
            display: block;
        }
        &__video {
            --video-x: 209;
            --video-y: 683;
            --video-width: 783;
            --video-height: 434;
            border-radius: 16px;
        }
        &__button {
            &--1 {
                --button-width: 515;
                --button-height: 120;
                --button-1-x: 351;
                --button-1-y: 5832;
            }
            &--2 {
                --button-width: 160;
                --button-height: 48;
                --button-2-x: 128;
                --button-2-y: 6268;
            }
            &--top {
                --button-width: 220;
                --button-height: 48;
                --button-top-x: 611;
                --button-top-y: 461;
            }
        }
    }
}
</style>